import { render, staticRenderFns } from "./PasswordRecoverySucess.vue?vue&type=template&id=6715e846&scoped=true"
import script from "./PasswordRecoverySucess.vue?vue&type=script&lang=js"
export * from "./PasswordRecoverySucess.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoverySucess.vue?vue&type=style&index=0&id=6715e846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715e846",
  null
  
)

export default component.exports